/**
 * author: Ananthapadmanabhan V K & Soumya Shreyas
 */
import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import "./RegulationReport.scss";
import { withTranslation } from "react-i18next";
import { Button, OverlayTrigger, Table, Collapse } from "react-bootstrap";
import { BiDownload, BiPencil, BiChevronDown } from "react-icons/bi";
import CompanyService from "../../../core/service/CompanyService";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
import ReportService from "../../../core/service/ReportService";
import Utils from "../../../core/utilities/Utils";
import { RegulationContext } from "../../../App";
import nodataimg from "../../../images/nodatafound.png"
import { FcFinePrint } from "react-icons/fc";


const RegulationReport = ({ t }) => {
  var lsDat = JSON.parse(localStorage.getItem("authority"));

  // const navigate = useNavigate();
  const companyId = lsDat.profile.company.id;
  const [regulations, setRegulations] = useState([]);
  const [regulationId, setRegulationId] = useState(null);
  const { glbRegulation, setGlbRegulation, glbRegulations } =
    useContext(RegulationContext);
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
  // const [shown, setShown] = useState({ [glbRegulationId]: true });
  const [shown, setShown] = useState({});
  useEffect(() => {
    getSubscriptions();
  }, []);
  const getSubscriptions = async (e) => {
    if (companyId) {
      CompanyService.getCompanySubscriptions(companyId)
        .then((response) => {
          var resRegulations = response.data.regulations;
          setRegulations([...resRegulations]);
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
        });
    }
  };
  const downloadReport = () => {
    // if(glbRegulationId!=null && glbRegulationId!=='' && glbRegulationId!==undefined) {
    ReportService.downloadReport(4)
      .then((response) => {
        const link = document.createElement("a");
        link.href =
          "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," +
          response.data.data;
        link.download = "Report.docx";
        link.click();
      })
      .catch((error) => {
        // //ErrorHandlingService.handleError(error.response.status);
        console.log("err", error);
      });
    // }
  };
  const handleExpand = (id) => {
    const newVal = !shown[id];
    var obj = function (shown) {
      Object.keys(shown).forEach(function (key) { shown[key] = false });
      return shown;
    }
    setShown({
      ...obj,
      [id]: newVal,
    });

  };
  return (
    <div className="RiskScore">
      <div className="List_header">
        <h5 className="MH">{t("Reports.label")}</h5>
      </div>
      <div className="RegulationReport">
        {regulations?.map((item, index) => (
          <div className="card RSW_Add_Card " key={item.id}>
            <div className="card-body p-0">
              <div className="RSW_Add_Card_row01">
                <div className="expand_RswBox" >
                  <BiChevronDown
                    onClick={(e) => handleExpand(item.id)}
                    aria-controls="example-collapse-text"
                    aria-expanded={shown[item.id]}
                  ></BiChevronDown>
                </div>
                <div className="row m-0">
                  <div className="col-lg-12 p-0">
                    <ul>
                      <li>
                        <h6 className="mb-0 me-2">{item.name}</h6>
                      </li>
                    </ul>
                  </div>
                  <Collapse in={shown[item.id]}>
                    <div className="col-lg-12 p-1 " id={item.id}>
                      {item.code === "LKSG" ? (
                        <div className="col-lg-8 p-1">
                          <div className="List_Table_01">
                            <div className="card List_table-card01">
                              <Table responsive="sm">
                                <thead>
                                  <tr>
                                    <th>{t("AnnualReport.label")}</th>
                                    <th>{t("Date.label")}</th>
                                    <th>{t("Action.label")}</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>LKSG Annual Report 2022</td>
                                    <td></td>
                                    <td>
                                      <Button>Generate</Button>
                                    </td>
                                    <td>
                                      <div>
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={Utils.renderTooltip(
                                            t("Download.label")
                                          )}
                                        >
                                          <span>
                                            <BiDownload
                                              className="cursor"
                                              onClick={() => downloadReport()}
                                            />
                                          </span>
                                        </OverlayTrigger>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>LKSG Annual Report 2021</td>
                                    <td>Dec 30, 2021</td>
                                    <td></td>
                                    <td>
                                      <div>
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={Utils.renderTooltip(
                                            t("Download.label")
                                          )}
                                        >
                                          <span>
                                            <BiDownload className="cursor" />
                                          </span>
                                        </OverlayTrigger>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>LKSG Annual Report 2020</td>
                                    <td>Dec 30, 2020</td>
                                    <td></td>
                                    <td>
                                      <div>
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={Utils.renderTooltip(
                                            t("Download.label")
                                          )}
                                        >
                                          <span>
                                            <BiDownload className="cursor" />
                                          </span>
                                        </OverlayTrigger>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        </div>
                      ) : (<div className="Nodatafound_box">
                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                      </div>)}
                    </div>
                  </Collapse>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default withTranslation()(RegulationReport);
